import React, { Component } from 'react';
import { connect } from 'react-redux';
import DonorSea from '../Components/Donor/DonorSea.js';
import timeHelpers from '../utils/timeHelpers.js';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import { loopIndex, getFileType, videoType, dpath } from '../utils/shared';
import _ from 'lodash';
import { safeJson } from '../utils/dataHelpers';

const _videoStyle = {
    preload: 'auto',
    position: 'fixed',
    minWidth: '100%',
    minHeight: '100%',
    width: '100%',
    height: '100%',
    zIndex: -100,
    loop: '',
    autoplay: "",
    muted: "",
    pointerEvents: "none"
}

class DonorSeaContainer extends Component {

    constructor(props) {
        super(props);
        this._seaConfig = null;
        this._cycleIntervals = null;
        this._config = {
            elementIntervalMS: null,
            elementStates: []
        }
        if (this.props.content.dm_active) {
            let dm = this.props.content.dm_active[this.props.active_module];
            if (dm) {

                let slideshow_module = _.find(this.props.content.dm_active, { id: Number(dm.contents.slideshow_module) });

                this._cycleIntervals = [];
                let cycleIntervals = _.get(slideshow_module, 'contents.cycle_overrides', []);
                cycleIntervals = cycleIntervals.map(interval => (interval*1000));

                let activeSlides = _.get(slideshow_module, 'contents.bool0s', []);

                this._seaConfig = dm.contents;
                let elementStates = slideshow_module.contents.images;
                this._config.elementStates = [];

                //only push active slides to array
                for (var b=0; b<elementStates.length; b++){
                    if (activeSlides[b]){
                        if (activeSlides[b]===true || activeSlides[b] ==='true'){
                            this._config.elementStates.push({...elementStates[b], cycleInterval: cycleIntervals[b] || 5000});
                            if (cycleIntervals[b]){
                                this._cycleIntervals.push(cycleIntervals[b]);
                            }
                            else{
                                this._cycleIntervals.push(5000);
                            }
                        }
                    }
                }

                this._slideshowConfig = slideshow_module.contents;
                if (this._config.elementStates.length === 1) {
                    this._config.elementStates.push(this._config.elementStates[0]); //make an array of at least two for the purposes of transitions
                }

                this._intervalTimeoutMS = timeHelpers.timeIntervalRemainderArrayMS(this._cycleIntervals);
            }
            else {
                console.log('no donor sea module found');
            }
        }
        if (!this._config.elementIntervalMS) {
            console.log("There is an issue establishing the cycle length, check that the video slideshow module's first slide has a cycle time")
        }

        let elementIndex = timeHelpers.indexFromIntervalArray(this._cycleIntervals, this._config.elementStates.length);
        let currentTimeInterval = timeHelpers.currentSeekTimeArray(this._cycleIntervals);
        this.state = {
            elementIndex: elementIndex,
            nameCount: 0,
            namesDisplayed: 0,
            secondsPassed: 0,
            sinceElement: 0,
            showDebug: 0,
            currentTimeInterval: currentTimeInterval,
            contentStage: 2
        };

        this._currentVideoRef = null;
        this._intervalTimeout = null;
        this._intervalSeekTimeout = null;
        this._startTime = new Date();
        this._elementCycleTime = new Date();

        for (var i = 0; i < this._seaConfig.ranks.length; i++) {
            this._seaConfig.ranks[i].fontSize = (this._seaConfig.ranks[i].fontSize / 100).toFixed(5)
        }
        this._seaConfig.initDuration = this._seaConfig.initDuration * 1000
        this._seaConfig.cycleTimeInit = this._seaConfig.cycleTimeInit * 1000
        this._seaConfig.cycleTime = this._seaConfig.cycleTime * 1000
        this._seaConfig.nameMargin = this._seaConfig.nameMargin / 100;
        this._seaConfig.edgeMargin = this._seaConfig.edgeMargin / 100;
        this._loops = 0;

        //temporary
        this._fadeOutTime = 50000
        this._fadeOutTimeout = null;
    }


    componentDidMount() {
        this.setupIntervalHandler();
        this.setVideoSeekTimeInterval();
        document.addEventListener("keydown", this.handleKeyDown);
    }

    componentDidUpdate() {
        if (this.state.contentStage === 1) {
            this.setState({
                contentStage: 2
            })
        }
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown);
        clearTimeout(this._intervalTimeout);
        clearTimeout(this._intervalSeekTimeout);
        clearTimeout(this._fadeOutTimeout);
        this._intervalTimeout = null;
        this._intervalSeekTimeout = null;
        this._fadeOutTimeout = null;
    }

    handleKeyDown = (event) => {
        switch (event.key) {
            case "s":
                console.log(this.props);
                break;
            case "d":
                let newDebug = this.state.showDebug + 1
                if (newDebug > 2) {
                    newDebug = 0
                }
                this.setState({
                    showDebug: newDebug
                })
                break;
            case "n":
                if (this.state.contentStage === 0) { //fade out names
                    this.setState({
                        contentStage: 1
                    })
                }
                else if (this.state.contentStage === 2) { //start names fade in
                    this.setState({
                        contentStage: 0
                    })
                }
                break;
            default:
                break;
        }
    }

    handleStats = (nameCount, displayed) => {
        if (this.state.showDebug) {
            this.setState({
                nameCount: nameCount,
                namesDisplayed: displayed,
                secondsPassed: timeHelpers.diff(this._startTime, new Date(), "seconds"),
                sinceElement: timeHelpers.diff(this._elementCycleTime, new Date(), "seconds")
            })
        }
    }
    // Setup the interval handler that will loop through the background
    // every {elementInterval} amount of time and through every element
    // in this._config.elementStates

    setupIntervalHandler = () => {
        // console.log("A3 Setup Interval", new Date().toTimeString().split(' ')[0]);
        //video before last
        if (this.state.elementIndex===this._config.elementStates.length - 2){ //fade names out a second before end of video
            this._fadeOutTime = this._intervalTimeoutMS - 2000; //2 seconds before end of clip proceeding last
            if (this._fadeOutTime < 0) {
                this.setState({
                    contentStage: 1 //already faded out
                })
                this._fadeOutTime = 0; //next frame
            }
            else {
                this.setState({
                    contentStage: 0 //normal show names
                })
                this._fadeOutTimeout = setTimeout(() => {
                    this.setState({
                        contentStage: 1 //issue fadeout
                    })
                }, this._fadeOutTime)
            }
        }
        else if (this.state.elementIndex===this._config.elementStates.length - 1) //handle last video
        {
            this.setState({
                contentStage: 1 //don't show any names
            })
        }
        else{ //handle all proceeding videos
            this.setState({
                contentStage: 0 //normal show names
            })
        }
    
        clearTimeout(this._intervalTimeout);
        this._intervalTimeout = null;
        this._intervalTimeout = setTimeout(() => {    
            
            this._intervalTimeoutMS = timeHelpers.timeIntervalRemainderArrayMS(this._cycleIntervals);

            if (this._intervalTimeoutMS > 500){
                let elementIndex = loopIndex(this.state.elementIndex, 0, this._config.elementStates.length - 1, "forward");
                this.setState({
                    elementIndex: elementIndex
                })
                this._elementCycleTime = new Date();
                console.log("A3 this._intervalTimeoutMS: " + this._intervalTimeoutMS, "elementIndex: "+elementIndex, new Date().toTimeString().split(' ')[0]);
            }

            this.setupIntervalHandler();
        }, this._intervalTimeoutMS);
    }

    logDebug = (obj) => {
        if (this.state.showDebug === 2) {
            console.log(obj);
        }
    }

    setVideoSeekTimeInterval = () => {
        clearTimeout(this._intervalSeekTimeout);
        this._intervalSeekTimeout = null;
        this._intervalSeekTimeout = setTimeout(() => {
            let fileType = getFileType(this._config.elementStates[this.state.elementIndex].file_name);
            if (fileType === "video") {
                if (!this._currentVideoRef) {
                    this.setVideoSeekTimeInterval();
                } else {
                    this._currentVideoRef.currentTime = (this.state.currentTimeInterval / 1000);
                    clearTimeout(this._intervalSeekTimeout);
                }
            }
        }, 30);
    }

    showBezelHandle = (screensH, screensV) => {
        if (this.state.showDebug !== 1) {
            return (
                null
            )
        }

        let debugBoxStyle = {
            position: 'absolute',
            borderStyle: 'solid',
            borderWidth: this.props.screen.screenHeight * .005,
            width: this.props.screen.screenWidth / screensH,
            height: this.props.screen.screenHeight / screensV,
            opacity: .7
        }

        if (screensH === 5 && screensV === 2) {
            return (
                <div>
                    <div style={{ ...debugBoxStyle, left: 0, top: 0 }} />
                    <div style={{ ...debugBoxStyle, left: this.props.screen.screenWidth / 5, top: 0 }} />
                    <div style={{ ...debugBoxStyle, left: (this.props.screen.screenWidth / 5) * 2, top: 0 }} />
                    <div style={{ ...debugBoxStyle, left: (this.props.screen.screenWidth / 5) * 3, top: 0 }} />
                    <div style={{ ...debugBoxStyle, left: (this.props.screen.screenWidth / 5) * 4, top: 0 }} />
                    <div style={{ ...debugBoxStyle, left: 0, top: this.props.screen.screenHeight / 2, borderStyle: 'solid' }} />
                    <div style={{ ...debugBoxStyle, left: this.props.screen.screenWidth / 5, top: this.props.screen.screenHeight / 2 }} />
                    <div style={{ ...debugBoxStyle, left: (this.props.screen.screenWidth / 5) * 2, top: this.props.screen.screenHeight / 2 }} />
                    <div style={{ ...debugBoxStyle, left: (this.props.screen.screenWidth / 5) * 3, top: this.props.screen.screenHeight / 2 }} />
                    <div style={{ ...debugBoxStyle, left: (this.props.screen.screenWidth / 5) * 4, top: this.props.screen.screenHeight / 2 }} />
                </div>
            )
        }
        if (screensH === 4 && screensV === 2) {
            return (
                <div>
                    <div style={{ ...debugBoxStyle, left: 0, top: 0 }} />
                    <div style={{ ...debugBoxStyle, left: this.props.screen.screenWidth / 4, top: 0 }} />
                    <div style={{ ...debugBoxStyle, left: (this.props.screen.screenWidth / 4) * 2, top: 0 }} />
                    <div style={{ ...debugBoxStyle, left: (this.props.screen.screenWidth / 4) * 3, top: 0 }} />
                    <div style={{ ...debugBoxStyle, left: 0, top: this.props.screen.screenHeight / 2, borderStyle: 'solid' }} />
                    <div style={{ ...debugBoxStyle, left: this.props.screen.screenWidth / 4, top: this.props.screen.screenHeight / 2 }} />
                    <div style={{ ...debugBoxStyle, left: (this.props.screen.screenWidth / 4) * 2, top: this.props.screen.screenHeight / 2 }} />
                    <div style={{ ...debugBoxStyle, left: (this.props.screen.screenWidth / 4) * 3, top: this.props.screen.screenHeight / 2 }} />
                </div>
            )
        }
        else if (screensH === 3 && screensV === 2) {
            return (
                <div>
                    <div style={{ ...debugBoxStyle, left: 0, top: 0 }} />
                    <div style={{ ...debugBoxStyle, left: this.props.screen.screenWidth / 3, top: 0 }} />
                    <div style={{ ...debugBoxStyle, left: (this.props.screen.screenWidth / 3) * 2, top: 0 }} />
                    <div style={{ ...debugBoxStyle, left: 0, top: this.props.screen.screenHeight / 2, borderStyle: 'solid' }} />
                    <div style={{ ...debugBoxStyle, left: this.props.screen.screenWidth / 3, top: this.props.screen.screenHeight / 2 }} />
                    <div style={{ ...debugBoxStyle, left: (this.props.screen.screenWidth / 3) * 2, top: this.props.screen.screenHeight / 2 }} />
                </div>
            )
        }
        else if (screensH === 1 && screensV === 2) {
            return (
                <div>
                    <div style={{ ...debugBoxStyle, left: 0, top: 0 }} />
                    <div style={{ ...debugBoxStyle, left: 0, top: this.props.screen.screenHeight / 2 }} />
                </div>
            )
        }
        else {
            return (
                null
            )
        }
    }

    render() {
        try {
            let seaContents = this.props.content.dm_active[this.props.active_module].contents;
            let fileType = getFileType(this._config.elementStates[this.state.elementIndex].file_name);
            let cType = "";
            let content = "";
    
            let donorSeaBox = {
                left: 0,
                top: 0,
                width: this.props.screen.screenWidth,
                height: this.props.screen.screenHeight
            }
            let fullpath = dpath(this.props.screen.mode, this._config.elementStates[this.state.elementIndex].path, this._config.elementStates[this.state.elementIndex].file_name, this.props.screen.webkey);
            if (fileType === "video") {
                cType = videoType(this._config.elementStates[this.state.elementIndex].file_name);
                content = (<div className="vid" style={{ position: 'absolute', top: 0, left: 0 }} key={this.state.elementIndex}>
                    <video style={_videoStyle} ref={el => this._currentVideoRef = el} id="background-video" loop autoPlay muted>
                        <source src={fullpath} type={cType} />
                        Your browser does not support the video tag.
                                </video>
                </div>);
            } else {
                content =(<div style={{ ...donorSeaBox, zIndex: -100, position: 'absolute', backgroundSize: "cover", backgroundImage: "url(" + fullpath + ")" }} />);
            }
    
            let opacity = Number(_.get(this._slideshowConfig.custom_fields, 'overlay_opacity.val', 0));
            let overlayCss = {
                backgroundColor: _.get(this._slideshowConfig.custom_fields, 'overlay_color.val', '#FFFFFF'),
                opacity: opacity !== 0 ? opacity / 100 : opacity,
                position: 'absolute',
                width: this.props.screen.screenWidth,
                height: this.props.screen.screenHeight
            }
    
            return (
                <div style={{ position: 'absolute', top: 0, left: 0, width: this.props.screen.screenWidth, height: this.props.screen.screenHeight }}>
    
                    <CSSTransitionGroup
                        component='div'
                        transitionName='slowfadedelay'
                        transitionEnterTimeout={0}
                        transitionLeaveTimeout={0}>
                        <div key={this.state.elementIndex}>
                            {content}
                        </div>
                    </CSSTransitionGroup>

                    <CSSTransitionGroup
                        component='div'
                        transitionName='slowfadedelay'
                        transitionEnterTimeout={0}
                        transitionLeaveTimeout={0}>
                        <div key={this.state.contentStage}>
                            {
                                this.state.contentStage === 0 ?
                                    <div style={overlayCss}></div> : null
                            }
                        </div>
                    </CSSTransitionGroup>
    
                    <DonorSea
                        left={donorSeaBox.left}
                        top={donorSeaBox.top}
                        width={donorSeaBox.width}
                        height={donorSeaBox.height}
                        screen={this.props.screen}
                        elementIndex={this.state.elementIndex}
                        handleStats={this.handleStats}
                        config={this._seaConfig}
                        screensH={seaContents.screensH}
                        screensV={seaContents.screensV}
                        allowedScreens={this.props.allowedScreens}
                        contentStage={this.state.contentStage}
                    />
    
                    {/* background info div */}
                    {this.showBezelHandle(seaContents.screensH, seaContents.screensV)}
                    {this.state.showDebug === 2 ?
                        <div style={{ position: 'absolute', color: 'white', top: 0, left: 0, width: this.props.screen.screenWidth / 3, height: this.props.screen.screenHeight / 2, opacity: .9, backgroundColor: 'black' }}>
                            <div style={{ marginLeft: this.props.screen.screenHeight * .01, marginTop: this.props.screen.screenHeight * .02, fontSize: this.props.screen.screenHeight * .0175, width: this.props.screen.screenWidth / 3, height: this.props.screen.screenHeight / 2 }}>
                                <b>Donors</b><br />
                                Current Count: {this.state.nameCount}<br />
                                Total Displayed: {this.state.namesDisplayed}<br />
                                Elapsed Seconds: {this.state.secondsPassed}<br />
                                <br />
                                <b>Config</b><br />
                                textColor: {JSON.stringify(this._seaConfig.textColor)}<br />
                                cycleTimeInit: {JSON.stringify(this._seaConfig.cycleTimeInit)}<br />
                                initDuration: {JSON.stringify(this._seaConfig.initDuration)}<br />
                                cycleTime: {JSON.stringify(this._seaConfig.cycleTime)}<br />
                                ranks: {JSON.stringify(this._seaConfig.ranks)}<br />
                                nameMargin: {JSON.stringify(this._seaConfig.nameMargin)}<br />
                                edgeMargin: {JSON.stringify(this._seaConfig.edgeMargin)}<br />
                                Seconds Interval: {this.state.sinceElement}<br />
                            </div>
                        </div>
                        :
                        null
                    }
    
                </div>
            )
        } catch(e) {
            console.log(e)
        }
    }
}

const mapStateToProps = (state) => {

    let allowedScreens = { enabled: false, allowedH: [], allowedV: [] };
    if (_.has(state, 'content.settings.custom_vars.allowedH')) {
        allowedScreens.enabled = true;
        allowedScreens.allowedH = safeJson(state.content.settings.custom_vars.allowedH) || [];
    }
    if (_.has(state, 'content.settings.custom_vars.allowedV')) {
        allowedScreens.enabled = true;
        allowedScreens.allowedV = safeJson(state.content.settings.custom_vars.allowedV) || [];
    }

    return {
        content: state.content,
        donors: state.donors,
        screen: state.screen,
        active_module: state.active_module,
        allowedScreens: allowedScreens
    };
};

const mapDispatchToProps = (dispatch) => {
    return {

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DonorSeaContainer);



// WEBPACK FOOTER //
// ./src/containers/DonorSeaContainer.js